// File to create different weather constants by classes.

export class Weather {
  public static PERILS = {
    HAIL: {
      NAME: "Hail",
      ICON: "hail",
      PROBABILITY: "hail-prob",
      SIZE: "hail-size",
    },
    WIND: {
      NAME: "Wind",
      ICON: "wind",
      MAX_GUST: "max-gust",
    },
    HURRICANE: {
      NAME: "Hurricane",
      ICON: "hurricane",
      H_MAX_GUST: "h-max-gust",
      H_MAX_WIND: "h-max-wind",
    },
  };

  public static STYLES = {
    "stroke-opacity": 0.8,
    "fill-opacity": 0.5,
    "hail-prob": {
      icon: "hail",
      feature: "prob",
      text: "Hail probability",
      units: "PROBABILITY",
      items: [
        {
          value: 5,
          red: 0,
          green: 128,
          blue: 255,
        },
        {
          value: 10,
          red: 6,
          green: 142,
          blue: 255,
        },
        {
          value: 15,
          red: 12,
          green: 156,
          blue: 153,
        },
        {
          value: 20,
          red: 19,
          green: 171,
          blue: 103,
        },
        {
          value: 25,
          red: 25,
          green: 185,
          blue: 52,
        },
        {
          value: 30,
          red: 32,
          green: 200,
          blue: 2,
        },
        {
          value: 35,
          red: 76,
          green: 211,
          blue: 1,
        },
        {
          value: 40,
          red: 121,
          green: 222,
          blue: 1,
        },
        {
          value: 45,
          red: 165,
          green: 233,
          blue: 0,
        },
        {
          value: 50,
          red: 210,
          green: 244,
          blue: 0,
        },
        {
          value: 55,
          red: 255,
          green: 255,
          blue: 0,
        },
        {
          value: 60,
          red: 255,
          green: 253,
          blue: 0,
        },
        {
          value: 65,
          red: 255,
          green: 204,
          blue: 0,
        },
        {
          value: 70,
          red: 255,
          green: 102,
          blue: 0,
        },
        {
          value: 75,
          red: 255,
          green: 51,
          blue: 0,
        },
        {
          value: 80,
          red: 255,
          green: 0,
          blue: 0,
        },
        {
          value: 85,
          red: 234,
          green: 0,
          blue: 42,
        },
        {
          value: 90,
          red: 213,
          green: 0,
          blue: 85,
        },
        {
          value: 95,
          red: 192,
          green: 0,
          blue: 198,
        },
        {
          value: 100,
          red: 171,
          green: 0,
          blue: 171,
        },
      ],
    },
    "hail-size": {
      icon: "hail",
      feature: "size",
      text: "Hail size",
      units: "LENGTH_SMALL",
      items: [
        {
          value: 0.75,
          red: 255,
          green: 248,
          blue: 120,
        },
        {
          value: 1,
          red: 255,
          green: 234,
          blue: 0,
        },
        {
          value: 1.25,
          red: 255,
          green: 196,
          blue: 0,
        },
        {
          value: 1.5,
          red: 255,
          green: 157,
          blue: 0,
        },
        {
          value: 1.75,
          red: 255,
          green: 157,
          blue: 0,
        },
        {
          value: 2,
          red: 255,
          green: 77,
          blue: 0,
        },
        {
          value: 2.25,
          red: 255,
          green: 38,
          blue: 0,
        },
        {
          value: 2.5,
          red: 255,
          green: 0,
          blue: 0,
        },
        {
          value: 2.75,
          red: 176,
          green: 18,
          blue: 0,
        },
        {
          value: 3,
          red: 135,
          green: 29,
          blue: 0,
        },
        {
          value: 3.25,
          red: 108,
          green: 0,
          blue: 117,
        },
        {
          value: 3.5,
          red: 176,
          green: 0,
          blue: 144,
        },
        {
          value: 3.75,
          red: 235,
          green: 0,
          blue: 211,
        },
        {
          value: 4,
          red: 255,
          green: 99,
          blue: 255,
        },
      ],
    },
    "max-gust": {
      icon: "wind",
      feature: "maxgust",
      text: "Wind max gust",
      units: "SPEED",
      items: [
        {
          value: 40,
          red: 150,
          green: 170,
          blue: 255,
        },
        {
          value: 45,
          red: 112,
          green: 127,
          blue: 255,
        },
        {
          value: 50,
          red: 75,
          green: 85,
          blue: 255,
        },
        {
          value: 55,
          red: 37,
          green: 42,
          blue: 255,
        },
        {
          value: 60,
          red: 0,
          green: 0,
          blue: 255,
        },
        {
          value: 65,
          red: 0,
          green: 0,
          blue: 234,
        },
        {
          value: 70,
          red: 0,
          green: 85,
          blue: 213,
        },
        {
          value: 75,
          red: 0,
          green: 127,
          blue: 192,
        },
        {
          value: 80,
          red: 0,
          green: 170,
          blue: 171,
        },
        {
          value: 85,
          red: 0,
          green: 212,
          blue: 150,
        },
        {
          value: 90,
          red: 0,
          green: 255,
          blue: 129,
        },
        {
          value: 95,
          red: 42,
          green: 255,
          blue: 107,
        },
        {
          value: 100,
          red: 85,
          green: 255,
          blue: 86,
        },
        {
          value: 105,
          red: 127,
          green: 255,
          blue: 64,
        },
        {
          value: 110,
          red: 170,
          green: 255,
          blue: 43,
        },
        {
          value: 115,
          red: 212,
          green: 255,
          blue: 21,
        },
        {
          value: 120,
          red: 255,
          green: 255,
          blue: 0,
        },
        {
          value: 125,
          red: 255,
          green: 212,
          blue: 0,
        },
        {
          value: 130,
          red: 255,
          green: 170,
          blue: 0,
        },
        {
          value: 135,
          red: 255,
          green: 127,
          blue: 0,
        },
        {
          value: 140,
          red: 255,
          green: 85,
          blue: 0,
        },
        {
          value: 145,
          red: 255,
          green: 42,
          blue: 0,
        },
        {
          value: 150,
          red: 255,
          green: 0,
          blue: 0,
        },
      ],
    },
    "h-max-gust": {
      icon: "hurricane",
      feature: "maxgust",
      text: "Hurricane max gust",
      units: "SPEED",
      items: [
        {
          value: 40,
          red: 150,
          green: 170,
          blue: 255,
        },
        {
          value: 45,
          red: 112,
          green: 127,
          blue: 255,
        },
        {
          value: 50,
          red: 75,
          green: 85,
          blue: 255,
        },
        {
          value: 55,
          red: 37,
          green: 42,
          blue: 255,
        },
        {
          value: 60,
          red: 0,
          green: 0,
          blue: 255,
        },
        {
          value: 65,
          red: 0,
          green: 0,
          blue: 234,
        },
        {
          value: 70,
          red: 0,
          green: 85,
          blue: 213,
        },
        {
          value: 75,
          red: 0,
          green: 127,
          blue: 192,
        },
        {
          value: 80,
          red: 0,
          green: 170,
          blue: 171,
        },
        {
          value: 85,
          red: 0,
          green: 212,
          blue: 150,
        },
        {
          value: 90,
          red: 0,
          green: 255,
          blue: 129,
        },
        {
          value: 95,
          red: 42,
          green: 255,
          blue: 107,
        },
        {
          value: 100,
          red: 85,
          green: 255,
          blue: 86,
        },
        {
          value: 105,
          red: 127,
          green: 255,
          blue: 64,
        },
        {
          value: 110,
          red: 170,
          green: 255,
          blue: 43,
        },
        {
          value: 115,
          red: 212,
          green: 255,
          blue: 21,
        },
        {
          value: 120,
          red: 255,
          green: 255,
          blue: 0,
        },
        {
          value: 125,
          red: 255,
          green: 212,
          blue: 0,
        },
        {
          value: 130,
          red: 255,
          green: 170,
          blue: 0,
        },
        {
          value: 135,
          red: 255,
          green: 127,
          blue: 0,
        },
        {
          value: 140,
          red: 255,
          green: 85,
          blue: 0,
        },
        {
          value: 145,
          red: 255,
          green: 42,
          blue: 0,
        },
        {
          value: 150,
          red: 255,
          green: 0,
          blue: 0,
        },
      ],
    },
    "h-max-wind": {
      icon: "hurricane",
      feature: "maxwind",
      text: "Hurricane max wind",
      units: "SPEED",
      items: [
        {
          value: 40,
          red: 150,
          green: 170,
          blue: 255,
        },
        {
          value: 45,
          red: 112,
          green: 127,
          blue: 255,
        },
        {
          value: 50,
          red: 75,
          green: 85,
          blue: 255,
        },
        {
          value: 55,
          red: 37,
          green: 42,
          blue: 255,
        },
        {
          value: 60,
          red: 0,
          green: 0,
          blue: 255,
        },
        {
          value: 65,
          red: 0,
          green: 0,
          blue: 234,
        },
        {
          value: 70,
          red: 0,
          green: 85,
          blue: 213,
        },
        {
          value: 75,
          red: 0,
          green: 127,
          blue: 192,
        },
        {
          value: 80,
          red: 0,
          green: 170,
          blue: 171,
        },
        {
          value: 85,
          red: 0,
          green: 212,
          blue: 150,
        },
        {
          value: 90,
          red: 0,
          green: 255,
          blue: 129,
        },
        {
          value: 95,
          red: 42,
          green: 255,
          blue: 107,
        },
        {
          value: 100,
          red: 85,
          green: 255,
          blue: 86,
        },
        {
          value: 105,
          red: 127,
          green: 255,
          blue: 64,
        },
        {
          value: 110,
          red: 170,
          green: 255,
          blue: 43,
        },
        {
          value: 115,
          red: 212,
          green: 255,
          blue: 21,
        },
        {
          value: 120,
          red: 255,
          green: 255,
          blue: 0,
        },
        {
          value: 125,
          red: 255,
          green: 212,
          blue: 0,
        },
        {
          value: 130,
          red: 255,
          green: 170,
          blue: 0,
        },
        {
          value: 135,
          red: 255,
          green: 127,
          blue: 0,
        },
        {
          value: 140,
          red: 255,
          green: 85,
          blue: 0,
        },
        {
          value: 145,
          red: 255,
          green: 42,
          blue: 0,
        },
        {
          value: 150,
          red: 255,
          green: 0,
          blue: 0,
        },
      ],
    },
  };

  public static getAllPerilTypes(): string[] {
    return [
      Weather.PERILS.HAIL.PROBABILITY,
      Weather.PERILS.HAIL.SIZE,
      Weather.PERILS.WIND.MAX_GUST,
      Weather.PERILS.HURRICANE.H_MAX_WIND,
      Weather.PERILS.HURRICANE.H_MAX_GUST,
    ];
  }
}
